export const isServer = typeof window == 'undefined';

export function getEnvVar(key: string) {
    return process.env[key] || key;
}

export const isMobile = () => {
    const ua = navigator.userAgent;
    return /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)
}

export const getApiUrl = () => {
    if (process.env.REACT_APP_USE_LOCAL_API_PROXY === 'true') {
        return '';
    }
    return getEnvVar('REACT_APP_BASE_URL');
};

export const getDomain = () => {
  return getEnvVar("REACT_APP_HOST");
};

